import './App.css';

import { Route, Routes } from 'react-router-dom';

import { AuthProvider } from './auth/AuthContext';
import { ProtectedRoute } from './auth/ProtectedRoute';
import NavBar from './components/NavBar';
import AdminAuditPage from './pages/AdminAuditPage';
import AdminErrorsPage from './pages/AdminErrorsPage';
import AdminNotificationsPage from './pages/AdminNotificationsPage';
import AdminPage from './pages/AdminPage';
import AdminSubscribersPage from './pages/AdminSubscribersPage';
import AdminUsersPage from './pages/AdminUsersPage';
import ApiDocsPage from './pages/ApiDocsPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import ConfirmPage from './pages/ConfirmPage';
import ErrorsPage from './pages/ErrorsPage';
import LoginPage from './pages/LoginPage';
import SubscribePage from './pages/SubscribePage';
import UnsubscribePage from './pages/UnsubscribePage';

export default function App() {
  return (
    <AuthProvider>
      <div className="app">
        <NavBar />
        <main className="main">
          <Routes>
            <Route element={<ApiDocsPage />} path="/" />
            <Route element={<ApiDocsPage />} path="/apis/:apiId" />
            <Route element={<ApiDocsPage />} path="/apis/:apiId/versions/:versionId" />
            {/* :section is a spec variant id (v0, v1, …), 'changelog' or 'migration' —
                pre-existing changelog/migration deep links resolve here. */}
            <Route element={<ApiDocsPage />} path="/apis/:apiId/versions/:versionId/:section" />
            {/* A service's guides: prose it publishes for integrators. Unversioned
                and public, like the error pages — see docs/service-guides.md. */}
            <Route element={<ApiDocsPage mode="guides" />} path="/apis/:apiId/guides" />
            <Route element={<ApiDocsPage mode="guides" />} path="/apis/:apiId/guides/:guideId" />
            {/* Unversioned + public: RFC 9457 `type` URIs in live API responses
                point here, and the readers are anonymous partners. Never add a
                version segment and never gate these behind auth. */}
            <Route element={<ErrorsPage />} path="/errors" />
            <Route element={<ErrorsPage />} path="/errors/:service" />
            <Route element={<ErrorsPage />} path="/errors/:service/:code" />
            <Route element={<LoginPage />} path="/login" />
            <Route element={<AuthCallbackPage />} path="/auth/callback" />
            <Route element={<SubscribePage />} path="/subscribe" />
            <Route element={<ConfirmPage />} path="/subscribe/confirm" />
            <Route element={<UnsubscribePage />} path="/unsubscribe" />
            <Route
              element={
                <ProtectedRoute minimumRole="developer">
                  <AdminPage />
                </ProtectedRoute>
              }
              path="/admin"
            />
            <Route
              element={
                <ProtectedRoute minimumRole="admin">
                  <AdminNotificationsPage />
                </ProtectedRoute>
              }
              path="/admin/notifications"
            />
            <Route
              element={
                <ProtectedRoute minimumRole="admin">
                  <AdminSubscribersPage />
                </ProtectedRoute>
              }
              path="/admin/subscribers"
            />
            <Route
              element={
                <ProtectedRoute minimumRole="admin">
                  <AdminUsersPage />
                </ProtectedRoute>
              }
              path="/admin/users"
            />
            <Route
              element={
                <ProtectedRoute minimumRole="admin">
                  <AdminAuditPage />
                </ProtectedRoute>
              }
              path="/admin/audit"
            />
            <Route
              element={
                <ProtectedRoute minimumRole="admin">
                  <AdminErrorsPage />
                </ProtectedRoute>
              }
              path="/admin/errors"
            />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  );
}
